import { useState, type CSSProperties } from 'react'
import { PRODUCT_IMAGE_EXTS, productImage } from '../lib/api'

/**
 * Product art lives in /public/products as <Name>.<ext> with mixed extensions
 * (svg/png/webp). This tries each in turn on load error, falling back to the
 * brand logo if none exist.
 */
export function ProductImage({
  name,
  alt = '',
  className,
  style,
}: {
  name: string
  alt?: string
  className?: string
  style?: CSSProperties
}) {
  const [attempt, setAttempt] = useState(0)
  const exhausted = attempt >= PRODUCT_IMAGE_EXTS.length
  const src = exhausted ? '/logo.webp' : productImage(name, PRODUCT_IMAGE_EXTS[attempt])

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={style}
      onError={() => {
        if (!exhausted) setAttempt((value) => value + 1)
      }}
    />
  )
}
